<template>
  <div :class="className">
    <header>
      <div class="title">
        <h3>{{ title }}</h3>
        <span class="tags">
          <span class="tag" v-for="tag in tags" :key="tag">
            {{ tag }}
          </span>
          <span class="tag current" v-if="current">current</span>
        </span>
      </div>
      <div class="time">
        {{ duration }}
      </div>
    </header>
    <p class="description">
      <slot></slot>
    </p>
    <div class="hashtags">
      <span class="hashtag" v-for="tag in hash_tags" :key="tag"
        >#{{ tag }}</span
      >
    </div>
  </div>
</template>

<script>
import cx from "classnames";

export default {
  name: "JobPosition",
  props: {
    current: Boolean,
    duration: String,
    description: String,
    hash_tags: Array,
    remote: Boolean,
    tags: Array,
    title: String
  },
  computed: {
    className() {
      return cx("JobPosition", {
        faded: !this.current
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.JobPosition {
  & + .JobPosition {
    margin-top: $spacing4;
    padding-top: $spacing4;
    border-top: 1px solid #c5c5c5;

    @media (min-width: 580px) {
      border-top: none;
      margin-top: $spacing8;
    }
  }

  &.faded {
    opacity: 0.5;
  }

  .title {
    margin-bottom: 0.4em;

    h3 {
      display: inline-block;
      margin-bottom: 0;
      margin-top: 0;
      margin-right: 0.4em;

      font-weight: bold;
      font-family: $font;
      color: #4d4d4d;
      font-size: 14px;
    }
  }

  .time {
    font-size: 10px;
    font-weight: 600;
  }

  .tag {
    display: inline-block;
    padding: 0.4em 1.2em;

    font: $font-alt;
    font-size: 10px;
    color: #fff;
    font-weight: 700;

    background: #d4e1b9;
    transform: rotate(-3deg);
    border-radius: 4px;

    & + .tag {
      margin-left: 0.4em;
    }

    &.current {
      background: $c-green;
    }
  }

  .description {
    font-weight: 300;
    font-size: 12px;
    line-height: 1.5;
  }

  .hashtags {
    color: #a0a0a0;
    font-weight: 700;
    font-size: 12px;

    .hashtag {
      &:not(:last-child):after {
        content: ", ";
      }
    }
  }
}
</style>
